import { GlobalMetricValueFormat } from '../types';

const formatMetricValue = (
    value: number,
    format: GlobalMetricValueFormat = 'none',
): string => {
    if (!Number.isFinite(value)) return '—';
    switch (format) {
        case 'currency':
            return new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: 'USD',
                notation: 'compact',
                minimumFractionDigits: 0,
                maximumFractionDigits: 1,
            }).format(value);
        case 'percentage':
            return `${value.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 0,
            })}%`;
        case 'integer':
            return Math.round(value).toLocaleString();
        case 'score':
            return `${value.toLocaleString(undefined, {
                maximumFractionDigits: 1,
                minimumFractionDigits: 0,
            })}`;
        case 'none':
        default:
            if (Number.isInteger(value)) return value.toLocaleString();
            return value.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });
    }
};

export default formatMetricValue;
